// extracted by mini-css-extract-plugin
export var copyableItem = "_i-0";
export var underlined = "_i-1";